import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appIpMask]',
})
export class IpMaskDirective {
  constructor(
    private el: ElementRef,
    @Optional() @Self() private control: NgControl | null
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const input = this.el.nativeElement;
    let value = input.value;
    const pos = input.selectionStart;

    // Rimuovi tutto tranne numeri e punti
    value = value.replace(/[^\d.]/g, '');

    // Previeni punti doppi
    value = value.replace(/\.{2,}/g, '.');

    // Previeni punto all'inizio
    if (value.startsWith('.')) {
      value = value.substring(1);
    }

    // Limita i segmenti
    const segments = value.split('.');
    const validSegments = segments.slice(0, 4).map((seg: any) => {
      if (seg === '') return seg;

      // Rimuovi zeri iniziali tranne se è solo "0"
      let clean = seg.replace(/^0+/, '') || '0';
      // Limita a 255
      let num = parseInt(clean, 10);
      if (num > 255) num = 255;
      return num.toString();
    });

    const newValue = validSegments.join('.');

    input.value = newValue;

    if (this.control?.control) {
      this.control.control.setValue(newValue, { emitEvent: false });
    }

    let newPos = pos;
    if (newValue.length < value.length) {
      newPos = Math.max(0, pos - (value.length - newValue.length));
    }
    input.setSelectionRange(newPos, newPos);
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = this.el.nativeElement;
    const pos = input.selectionStart ?? 0;
    let value = input.value;

    if (event.key === '.') {
      event.preventDefault();

      const beforeCursor = value.substring(0, pos);
      const currentSegmentIndex = beforeCursor.split('.').length - 1;

      if (currentSegmentIndex >= 3) {
        return;
      }

      const segments = value.split('.');
      let currentSegment = segments[currentSegmentIndex] || '';

      if (currentSegment === '') {
        return;
      }

      // NON fare padding, vai direttamente al prossimo segmento
      if (segments.length <= currentSegmentIndex + 1) {
        segments.push('');
      }

      const newValue = segments.join('.');
      input.value = newValue;

      if (this.control?.control) {
        this.control.control.setValue(newValue, { emitEvent: false });
      }

      const newPos = segments.slice(0, currentSegmentIndex + 1).join('.').length + 1;
      setTimeout(() => {
        input.setSelectionRange(newPos, newPos);
      }, 0);
    }

    if (event.key >= '0' && event.key <= '9') {
      const beforeCursor = value.substring(0, pos);
      const currentSegmentIndex = beforeCursor.split('.').length - 1;
      const segments = value.split('.');
      const currentSegment = segments[currentSegmentIndex] || '';

      if (currentSegment.length >= 3) {
        event.preventDefault();
      }
    }
  }

  @HostListener('blur')
  onBlur(): void {
    const input = this.el.nativeElement;
    const value = input.value;

    const segments = value.split('.');

    if (this.control?.control) {
      if (segments.length !== 4 || segments.some((seg: any) => seg === '')) {
        this.control.control.setErrors({ invalidIp: true });
      } else {
        const errors = this.control.control.errors;
        if (errors && errors['invalidIp']) {
          delete errors['invalidIp'];
          this.control.control.setErrors(Object.keys(errors).length ? errors : null);
        }
      }
    }
  }
}
